<template>
	<form ref="password_form" @submit.prevent="changePassword">
		<md-card>
			<md-card-header class="md-card-header-icon">
				<div class="card-icon">
					<i class="md-icon fas fa-key" style="color: white"></i>
				</div>
				<h4 class="title">
					Modification du mot de passe
				</h4>
			</md-card-header>

			<md-card-content>
				<div class="md-layout">
					<div class="md-layout-item md-size-100">
						<md-field class="md-invalid" style="margin-bottom: 30px">
							<label>Ancien mot de passe</label>
							<md-input v-model="password_old" type="password" required />
							<validation-error :errors="apiValidationErrors.password_old" />
						</md-field>
						<md-field class="md-invalid" style="margin-bottom: 30px">
							<label>Nouveau mot de passe</label>
							<md-input v-model="password" type="password" required />
							<validation-error :errors="apiValidationErrors.password" />
						</md-field>
						<md-field class="md-invalid">
							<label>Confirmez votre mot de passe</label>
							<md-input v-model="password_confirmation" type="password" required />
							<validation-error :errors="apiValidationErrors.password_confirmation" />
						</md-field>
					</div>
				</div>
			</md-card-content>

			<md-card-actions>
				<md-button type="submit">
					Changer mon mot de passe
				</md-button>
			</md-card-actions>
		</md-card>
	</form>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
export default {
	name: "edit-password-card",
	props: {
		user: Object,
	},
	components: { ValidationError },
	mixins: [formMixin],
	data: () => ({
		password_old: null,
		password: null,
		password_confirmation: null,
	}),
	methods: {
		async changePassword() {
			this.user.password_old = this.password_old;
			this.user.password = this.password;
			this.user.password_confirmation = this.password_confirmation;
			let data = {
				attributes: this.user
			}
			try {
				this.resetApiValidation();
				const response = await this.$store.dispatch("users/updatePassword", data);
				if(response) {
					await this.$store.dispatch("alerts/success","Mot de passe modifié");
					this.user = await this.$store.getters["profile/me"];
					this.$refs["password_form"].reset();
				}
			} catch (e) {
				let apiError = []
				if(e.response.data.errors) {
					let passwordErrors = this.checkArrayLength(e.response.data.errors['attributes.password'])
					let passwordOldErrors = this.checkArrayLength(e.response.data.errors['attributes.password_old'])
					apiError = passwordErrors.map(error => this.checkMessageError('password', error))
					apiError = [...apiError, ...passwordOldErrors.map(error => this.checkMessageError('password_old', error))]
					this.setApiValidation(apiError);
				} else {
					await this.$store.dispatch("alerts/error","Une erreur est survenue");
				}
			}
		},
		checkMessageError(field, error) {
			let errorMessage = ''
			switch(field) {
				case 'password':
					errorMessage = {
						source: { pointer: 'form/update/profile/password' },
						detail: error
					}
					break
				case 'password_old':
					errorMessage = {
						source: { pointer: 'form/update/profile/password_old' },
						detail: error
					}
					break
				default:
					errorMessage = {
						source: { pointer: 'form/update/profile/password_old' },
						detail: 'Une erreur est survenue'
					}
					break
			}
			return errorMessage
		},
		checkArrayLength(array) {
			if(array) {
				return array
			} else {
				return []
			}
		}
	},
};
</script>
